import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=36e58dfb&scoped=true"
var script = {}
import style0 from "./Pending.vue?vue&type=style&index=0&id=36e58dfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e58dfb",
  null
  
)

export default component.exports